<div fxLayout="column" fxFlex="100" fxLayoutGap="15px">
    <div fxLayout="column">
      <div fxLayout="row" class="space">
        <h3  fxLayoutAlign="center center"> Przypisz strukturę partnera </h3>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex="100">
          <app-dict-partners fxFlex="100" label="Partner" [formControl]="partnerControl" (selectedPartner)="partnerChanged($event)"></app-dict-partners>
        </div>
      </div>
    </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="end" fxLayoutGap="15px">
      <button (click)="partnerUpdate()" [class.spinner]="processingRequest" [disabled]="!partnerForm.valid" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
      <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    </div>
  </div>
</div>
